import styled from 'styled-components';
import { FlexBox } from '@Backlot-Cars/archie';

export const AuthCTAWrapper = styled(FlexBox).attrs({
	flexDirection: 'column',
	gap: 'lg',
	alignItems: 'center',
})`
	button {
		width: 100%;
	}

	a {
		font-size: 16px;
		text-align: center;
	}
`;
